"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationLimitStatusLabel = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var Label = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  line-height: 1.7;\n  label: RemainLabel;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  line-height: 1.7;\n  label: RemainLabel;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var RegistrationLimitStatusLabel = function (_a) {
    var value = _a.value, color = _a.color, className = _a.className, deadlineExceeded = _a.deadlineExceeded, hideRemain = _a.hideRemain;
    var label = getLabel(deadlineExceeded, value, hideRemain);
    if (label == null) {
        return null;
    }
    return (react_1.default.createElement(Label, { className: className, color: color }, label));
};
exports.RegistrationLimitStatusLabel = RegistrationLimitStatusLabel;
var getLabel = function (deadlineExceeded, value, hideRemain) {
    if (value <= 0) {
        return '残りなし';
    }
    if (deadlineExceeded) {
        return '期限が過ぎました';
    }
    if (hideRemain) {
        return null;
    }
    return "\u6B8B\u308A".concat(value);
};
var templateObject_1;
